module.exports = __webpack_public_path__ + "static/media/vclose.416466ab.svg";